import script from "./PsNavTabBar.vue?vue&type=script&lang=ts"
export * from "./PsNavTabBar.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__